require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-diversity-at-work-why-it-should-be-an-all-hands-mission.json") })
        }
      }, "path---blog-diversity-at-work-why-it-should-be-an-all-hands-mission");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-diversity-at-work-why-it-should-be-an-all-hands-mission!./.cache/json/blog-diversity-at-work-why-it-should-be-an-all-hands-mission.json
// module id = 786
// module chunks = 231608221292675